import React, { useEffect, useState } from "react";

const STORES = [
  { id: 6, name: "Niko 1" },
  { id: 3, name: "Niko 2" },
  { id: 1, name: "Niko 3" },
  { id: 2, name: "Niko 4" },
  { id: 4, name: "Niko 5" },
  { id: 5, name: "Niko 7" },
];

interface Feriado {
  id: number;
  fecha: string;
  nombre: string;
  todos_locales: boolean;
  stores: number[];
}

interface Props { token: string; }

export default function FeriadosPanel({ token }: Props) {
  const [feriados, setFeriados] = useState<Feriado[]>([]);
  const [fecha, setFecha] = useState("");
  const [nombre, setNombre] = useState("");
  const [todosLocales, setTodosLocales] = useState(true);
  const [storesSeleccionados, setStoresSeleccionados] = useState<number[]>([]);
  const [msg, setMsg] = useState("");

  const headers = { "Authorization": "Bearer " + token, "Content-Type": "application/json" };

  const load = () => {
    fetch("/api/feriados", { headers }).then(r => r.json()).then(setFeriados);
  };

  useEffect(() => { load(); }, []);

  const toggleStore = (id: number) => {
    setStoresSeleccionados(prev =>
      prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]
    );
  };

  const agregar = async () => {
    if (!fecha) { setMsg("Ingresa una fecha"); return; }
    const r = await fetch("/api/feriados", {
      method: "POST", headers,
      body: JSON.stringify({ fecha, nombre: nombre || "Feriado", todos_locales: todosLocales, stores: storesSeleccionados })
    });
    const data = await r.json();
    if (data.ok) {
      setMsg("Feriado agregado");
      setFecha(""); setNombre(""); setTodosLocales(true); setStoresSeleccionados([]);
      load();
    } else { setMsg("Error: " + JSON.stringify(data)); }
  };

  const eliminar = async (id: number) => {
    await fetch("/api/feriados/" + id, { method: "DELETE", headers });
    load();
  };

  const card: React.CSSProperties = { background: "#1e2a3a", borderRadius: "8px", padding: "20px", marginBottom: "24px" };
  const th: React.CSSProperties = { color: "#aaa", textAlign: "left", padding: "8px" };
  const td: React.CSSProperties = { color: "white", padding: "8px" };
  const inp: React.CSSProperties = { padding: "8px", borderRadius: "4px", border: "1px solid #444", background: "#0d1b2a", color: "white" };

  return (
    <div style={{ padding: "24px" }}>
      <h2 style={{ color: "white", marginBottom: "24px" }}>Feriados y Dias No Laborables</h2>

      <div style={card}>
        <h3 style={{ color: "white", marginBottom: "8px" }}>Domingos</h3>
        <p style={{ color: "#aaa", fontSize: "14px" }}>Los domingos estan excluidos automaticamente. No se enviaran alertas los dias domingo.</p>
      </div>

      <div style={card}>
        <h3 style={{ color: "white", marginBottom: "16px" }}>Feriados cargados</h3>
        {feriados.length === 0 && <p style={{ color: "#aaa" }}>No hay feriados cargados</p>}
        {feriados.length > 0 && (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #333" }}>
                <th style={th}>FECHA</th>
                <th style={th}>NOMBRE</th>
                <th style={th}>LOCALES</th>
                <th style={th}>ACCIONES</th>
              </tr>
            </thead>
            <tbody>
              {feriados.map(f => (
                <tr key={f.id} style={{ borderBottom: "1px solid #222" }}>
                  <td style={td}>{f.fecha}</td>
                  <td style={td}>{f.nombre}</td>
                  <td style={td}>{f.todos_locales ? "Todos" : STORES.filter(s => f.stores.includes(s.id)).map(s => s.name).join(", ")}</td>
                  <td style={{ padding: "8px" }}>
                    <button onClick={() => eliminar(f.id)} style={{ background: "#e74c3c", color: "white", border: "none", padding: "4px 12px", borderRadius: "4px", cursor: "pointer" }}>Eliminar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div style={card}>
        <h3 style={{ color: "white", marginBottom: "16px" }}>Agregar feriado</h3>
        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "12px" }}>
          <input type="date" value={fecha} onChange={e => setFecha(e.target.value)} style={inp} />
          <input type="text" placeholder="Nombre (ej: Dia Nacional)" value={nombre} onChange={e => setNombre(e.target.value)} style={{ ...inp, width: "200px" }} />
        </div>
        <div style={{ marginBottom: "12px" }}>
          <label style={{ color: "white", marginRight: "16px" }}>
            <input type="radio" checked={todosLocales} onChange={() => setTodosLocales(true)} style={{ marginRight: "6px" }} />
            Todos los locales cierran
          </label>
          <label style={{ color: "white" }}>
            <input type="radio" checked={!todosLocales} onChange={() => setTodosLocales(false)} style={{ marginRight: "6px" }} />
            Solo algunos locales cierran
          </label>
        </div>
        {!todosLocales && (
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "12px" }}>
            {STORES.map(s => (
              <label key={s.id} style={{ color: "white", display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                <input type="checkbox" checked={storesSeleccionados.includes(s.id)} onChange={() => toggleStore(s.id)} />
                {s.name}
              </label>
            ))}
          </div>
        )}
        <button onClick={agregar} style={{ background: "#2ecc71", color: "white", border: "none", padding: "8px 20px", borderRadius: "4px", cursor: "pointer", fontWeight: "bold" }}>
          Agregar feriado
        </button>
        {msg && <p style={{ color: msg.startsWith("Error") ? "#e74c3c" : "#2ecc71", marginTop: "8px" }}>{msg}</p>}
      </div>
    </div>
  );
}
